/**
 * Cycle Settings › Automations tab: same rule as the old dashboard email button.
 */
export function canManageCycleAutomations({
  clientNotificationEnabled,
  managerIds,
  userId,
  isFinancialCloseAdmin,
}) {
  if (!clientNotificationEnabled) return false;
  if (isFinancialCloseAdmin === true) return true;
  const id = userId != null ? String(userId) : '';
  if (!id) return false;
  return (managerIds || []).map(String).includes(id);
}
